export const COVER_IMAGE_MIME_TYPES = 'image/bmp, image/gif, image/jpeg, image/png, image/tiff, image/webp';

export const MIME_TYPE_ICON_MAPPING = Object.freeze({
  image: 'fa-file-image fa-regular',
  application: 'fa-file-lines fa-regular',
  text: 'fa-file-code fa-regular',
  default: 'fa-file fa-regular',
});
